import PropTypes from "prop-types";
import React, { Fragment, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { getCartData, deleteFromCart } from "../../redux/actions/cartActions";
import { getWishlist } from "../../redux/actions/wishlistActions";
import { useCartDrawer } from "../../contexts/CartDrawerContext";
import { resolveCartItemImageUrl } from "../../helpers/product";

const CartDrawer = ({
  cartData,
  currency,
  deleteFromCart,
  getCartData,
  getWishlist,
}) => {
  const { isCartDrawerOpen, closeCartDrawer } = useCartDrawer();
  const userInfo = useSelector((state) => state.userInfo);
  const addToast = () => {};

  useEffect(() => {
    if (isCartDrawerOpen && userInfo?.user) {
      getCartData(userInfo);
      getWishlist(userInfo);
    }
  }, [isCartDrawerOpen, userInfo, getCartData, getWishlist]);

  useEffect(() => {
    if (isCartDrawerOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [isCartDrawerOpen]);

  let cartTotalPrice = 0;

  if (!isCartDrawerOpen) {
    return null;
  }

  return (
    <div className="cart-drawer-root" role="dialog" aria-modal="true" aria-labelledby="cart-drawer-title">
      <button
        type="button"
        className="cart-drawer-backdrop"
        aria-label="Close cart"
        onClick={closeCartDrawer}
      />
      <aside className="cart-drawer-panel">
        <div className="cart-drawer-header">
          <h2 id="cart-drawer-title">Shopping cart</h2>
          <button
            type="button"
            className="cart-drawer-close"
            onClick={closeCartDrawer}
            aria-label="Close"
          >
            <i className="pe-7s-close" />
          </button>
        </div>

        <div className="cart-drawer-body">
          {cartData && cartData.length > 0 ? (
            <ul className="cart-drawer-list">
              {cartData.map((single, key) => {
                const offerPrice =
                  single.variant?.offer_price ?? single.offer_price;
                const variantId =
                  single.variant?.id ?? single.variant_id ?? single.id;
                const name = single.variant?.name ?? single.name;
                cartTotalPrice += offerPrice * single.quantity;
                return (
                  <li className="cart-drawer-item" key={key}>
                    <div className="cart-drawer-item__img">
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + variantId}
                        onClick={closeCartDrawer}
                      >
                        <img
                          alt=""
                          src={resolveCartItemImageUrl(single)}
                          className="img-fluid"
                        />
                      </Link>
                    </div>
                    <div className="cart-drawer-item__info">
                      <h4>
                        <Link
                          to={process.env.PUBLIC_URL + "/product/" + variantId}
                          onClick={closeCartDrawer}
                        >
                          {name}
                        </Link>
                      </h4>
                      <span className="cart-drawer-item__qty">
                        Qty: {single.quantity}
                      </span>
                      <span className="cart-drawer-item__price">
                        {currency.currencySymbol}
                        {(offerPrice * single.quantity).toFixed(2)}
                      </span>
                    </div>
                    <button
                      type="button"
                      className="cart-drawer-item__remove"
                      onClick={() => deleteFromCart(single, addToast)}
                      aria-label="Remove item"
                    >
                      <i className="fa fa-times-circle" />
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="cart-drawer-empty text-center">Your cart is empty</p>
          )}
        </div>

        <div className="cart-drawer-footer">
          {cartData && cartData.length > 0 ? (
            <Fragment>
              <div className="cart-drawer-total">
                <span>Subtotal</span>
                <strong>
                  {currency.currencySymbol + cartTotalPrice.toFixed(2)}
                </strong>
              </div>
              <div className="cart-drawer-actions btn-hover">
                <Link
                  className="default-btn cart-drawer-btn-secondary"
                  to={process.env.PUBLIC_URL + "/cart"}
                  onClick={closeCartDrawer}
                >
                  View cart
                </Link>
                <Link
                  className="default-btn"
                  to={process.env.PUBLIC_URL + "/checkout"}
                  onClick={closeCartDrawer}
                >
                  Checkout
                </Link>
              </div>
            </Fragment>
          ) : (
            <Link
              className="default-btn w-100 text-center d-block"
              to={process.env.PUBLIC_URL + "/products"}
              onClick={closeCartDrawer}
            >
              Continue shopping
            </Link>
          )}
        </div>
      </aside>
    </div>
  );
};

CartDrawer.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  deleteFromCart: PropTypes.func,
  getCartData: PropTypes.func,
  getWishlist: PropTypes.func,
};

const mapStateToProps = (state) => ({
  cartData: state.cartData,
  currency: state.currencyData,
});

const mapDispatchToProps = (dispatch) => ({
  deleteFromCart: (item, addToast) => {
    dispatch(deleteFromCart(item, addToast));
  },
  getCartData: (userInfo) => {
    dispatch(getCartData(userInfo));
  },
  getWishlist: (userInfo) => {
    dispatch(getWishlist(userInfo));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CartDrawer);
